<template>
    <div class="content">
      <div class="search">
        <el-cascader
            :placeholder="$t('pleaseSelect')"
            v-model="cascader"
            :options="options"
            :show-all-levels="false"
            :props="{ checkStrictly: true, value:'id', label: 'name', children: 'child'}"
            clearable></el-cascader>
        <el-button type="primary" @click="search">
            <!-- 搜索 -->
            {{$t('search')}}
        </el-button>
      </div>


        <div class="wrapper">
            <div class="main">
            <div class="list">
                <div class="item" v-for="(item,index) in goodsData" :key="index">
                <div class="img-wrap">
                    <img v-lazy="item.image_url" :alt="item.goods_name" :key="item.image_url">
                </div>
                <div class="title">{{item.product.name}}</div>
                <div class="price">{{$t('AboutToReturn')}} {{$t('currencySymbol')}}{{item.product.promotion_amount}} </div>
                <div class="price" v-if="item.product.staff.is_main=='1'">{{$t('channelPrice')}}{{$t('currencySymbol')}}{{item.price}}  </div>
                <div class="price channel" v-if="item.product.staff.is_main=='1'">
                    {{$t('channelSalePrice')}}
                    <span>
                        {{$t('currencySymbol')}} {{item.product.origin_price}}
                    </span> 
                </div>

                <div class="price" v-if="item.product.staff.is_main=='2'">{{$t('channelSalePrice')}}{{$t('currencySymbol')}}{{item.product.origin_price}}  </div>




                <div class="actions">
                    <a href="javascript:;" class="detail" @click="lookDetail(item)">{{$t('share')}}</a>
                    <!-- <a href="javascript:;" class="del" @click="delCollete(item.goods_id,index)">{{$t('del')}}</a> -->
                    
                </div>
                </div>
            </div>
            <template v-if="goodsData.length>0">
                <Pagination :totalPage="totalPage" :limit="form.limit" @changePage="handOrderMore"></Pagination>
            </template>
            </div>
        </div>
        
  </div>
</template>

<script>
import Pagination from "@/components/common/Pagination.vue";
import {apiBaseUrl} from '@/config/env.js'

export default {
    components: { Pagination },
    data() {
        return {
            options: [],
            cat_id: '', // 分类id
            search_name: '',
            form: {
                show_commission: 1,
                page: 1,
                limit: 12,
                where: {
                    retail: 1,
                }
            },
            goodsData: [],
            cascader: '',
            totalPage: '',
            invite: ''
            
        }
    },
    methods: {
        init() {
            this.$api.categories({}).then(res => {
				if (res.status) {
                    this.options = res.data;
				}
			});
        },
        handOrderMore(v) {
            this.form.page = v
            this.goods()
        },
        search() {
            this.form.page = 1
            this.goods()
        },
        goods() {
            
            let copy = JSON.parse( JSON.stringify(this.form))

            if(this.cascader.length > 0) {
                console.log(this.cascader)
                copy.where.cat_id = this.cascader[this,this.cascader.length - 1]
            }

            copy.where = JSON.stringify(copy.where)
            copy.token= this.$storage.get("userToken")
            
            this.$api.goodsList(copy).then(res => {
                if(res.status) {

                    this.totalPage = res.data.total_page
                    this.goodsData = res.data.list
                }
            })
        },
        lookDetail(val) {
            let url = `${apiBaseUrl}web/#/detail/${val.id}/${this.invite}`
            this.$alert(url, this.$t('shareLink'), {
            });
        }
    },
    created() {
        this.init()
        this.goods()

        this.$api.shareCode({}).then(res => {
        if(res.status) {
          // localStorage.setItem('invite', res.data)

          this.invite = res.data
        }
      })
    }
}
</script>

<style lang="scss" scoped>
@import "../Favourite.scss";
.search{
    .el-button {
        margin-left: 20px;
    }
}
.price.channel{
    color: #999 !important;
    font-size: 12px;
}
.price {
    span {
        text-decoration: line-through;
    }
}
</style>